<div class="steps">
  <span>Please follow the instructions to enable 2-factor authentication:</span>
  <div class="step">
    <b>Step 1:</b>
    <span
      >Install the Google Authenticator application from
      <a target="_blank" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pcampaignid=web_share">here</a>, if not
      already installed.</span
    >
  </div>
  <div class="step">
    <b>Step 2:</b>
    <span>Open the authenticator application and add an account.</span>
  </div>
  <div class="step">
    <b>Step 3:</b>
    <div class="step-3">
      <div class="step-3-desc">
        <span class="desc-left"
          >If using a laptop, kindly scan the below QR code from your smartphone to add the 2FA to your Google Authenticator Application.</span
        >
        <span class="desc-mid">OR</span>
        <span class="desc-right">If you are using a smartphone, manually copy the below code to your authenticator application.</span>
      </div>
      <div class="step-3-links">
        <div class="qr-code">
          @if (setupData?.provisioning_uri) {
            <qrcode [qrdata]="setupData?.provisioning_uri" />
          }
        </div>
        <div class="setup-key">
          <b>Setup Key:</b>
          <mat-form-field appearance="outline" color="primary">
            <input disabled matInput placeholder="Enter setup key" [value]="setupData?.secret" />
            @if (setupData?.secret) {
              <mat-icon matIconSuffix (click)="handleCopy(setupData?.secret)">content_copy</mat-icon>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="step">
    <b>Step 4:</b>
    <span>Click on continue after 6-digit authentication code is generated on Google Authenticator application.</span>
  </div>
</div>
<div class="actions">
  <button class="action-button" [disabled]="!setupData" (click)="onContinue.emit()">Continue</button>
  <button class="action-button" mat-dialog-close>Quit Setup</button>
</div>
